/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Li3Inputs */

const tr_mesafeli_s6_li3 = /** @type {(inputs: Mesafeli_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedel değişikliği yalnızca yeni dönem için geçerlidir ve ödeme öncesinde Platform'da gösterilir; ödenmiş dönemin bedeli değişmez.`)
};

const en_mesafeli_s6_li3 = /** @type {(inputs: Mesafeli_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A price change applies only to a new term and is shown on the Platform before payment; the price of the paid term does not change.`)
};

const de_mesafeli_s6_li3 = /** @type {(inputs: Mesafeli_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Preisänderung gilt nur für eine neue Laufzeit und wird vor der Zahlung auf der Plattform angezeigt; der Preis der bezahlten Laufzeit ändert sich nicht.`)
};

const ru_mesafeli_s6_li3 = /** @type {(inputs: Mesafeli_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение стоимости действует только для нового срока и показывается на Платформе до оплаты; стоимость оплаченного срока не меняется.`)
};

/**
* | output |
* | --- |
* | "A price change applies only to a new term and is shown on the Platform before payment; the price of the paid term does not change." |
*
* @param {Mesafeli_S6_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_li3 = /** @type {((inputs?: Mesafeli_S6_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_li3(inputs)
	if (locale === "de") return de_mesafeli_s6_li3(inputs)
	if (locale === "ru") return ru_mesafeli_s6_li3(inputs)
	return tr_mesafeli_s6_li3(inputs)
});